module.exports = __webpack_public_path__ + "img/gateway-65.1b15cd09.png";